import homeAirportSagas from '@kupibilet/forms/es/HomeAirport/sagas'

const sagas = () => [homeAirportSagas()]

export default sagas
